export default "__VITE_ASSET__fe49cacc__"